<template>
  <div class="asso-team-portal">
    <MessageBoard />
    <AddMessage :messageTopics="messageTopics" />
    <TournamentAddGameModal :association_id="association_id" :eventId="eventId" />
    <div class="asso-sec-content">
      <div class="d-flex justify-content-between flex-wrap" style="gap: 15px;"
        v-if="currentIsAdmin == '1' || currentIsUmpire == '1'">
        <div class="dropdown-wrapper">
          <button class="dropdown-button" :class="{ 'has-value': selectedTopic }" @click="toggleDropdown"
            v-click-outside="closeDropdown">
            <span>{{ selectedTopicName || 'Topic' }}</span>
            <img :src="arrow_down" alt="arrow-down" />
          </button>
          <div class="dropdown-menu-content" v-if="activeDropdown">
            <div v-if="messageTopics.length === 0" class="no-results">No results found</div>
            <div v-else>
              <div v-for="topic in messageTopics" :key="topic.id" class="dropdown-item" @click="selectTopic(topic)">
                <span>{{ topic.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <button class="btn manage-btn" @click="messageModal()">
          New Message
        </button>
        <!-- <router-link to="/message-board" class="m-0">Message</router-link> -->
      </div>
      <b-row class="no-gutters" v-if="messageBodyData.length > 0">
        <div class="col-12 products-column">
          <div class="message-card" v-for="item in messageBodyData" :key="item.id">
            <div @click="handleRowClick(item)">
              <div class="d-flex justify-content-between align-items-start">
                <div class="text-left">
                  <img v-if="item?.starred === 1" src="../../assets/Svg/star.svg" alt="">
                  <span class="team-rating">{{ item?.user?.name || '' }} - {{
                    formatDate(item.message_date) }}</span>
                  <h5 class="message-topic">{{ item.message_subject }}</h5>
                </div>
                <div class="icons-side">
                  <div class="back-square">
                    <img src="../../assets/Svg/back-square.svg" alt="Replies" />
                    <span>{{ item.replies_count }}</span>
                  </div>
                  <div class="back-square">
                    <img src="../../assets/Svg/eye.svg" alt="Views" />
                    <span>{{ item.views_count }}</span>
                  </div>
                </div>
              </div>
              <div class="message-body">
                <p class="message-content-infos">{{ item.message_body }}</p>
              </div>
            </div>
          </div>

          <content-placeholders :rounded="true" v-if="showLoaderMessage">
            <content-placeholders-heading :img="false" />
          </content-placeholders>
        </div>

      </b-row>
      <div v-if="messageBodyData.length" v-observe-visibility="handleScrolledToButtom"></div>

      <div class="no-event-wrap" v-if="
        (!messageBodyData || messageBodyData.length === 0) && showLoaderMessage === 0
      ">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No message found.</p>
        <p class="info">
          There are no message to display.
        </p>
      </div>

      <div class="products-list-shim p-0 mt-3" v-if="showLoaderMessage == 1">
        <content-placeholders :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
        <content-placeholders class="mt-3" :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
      </div>
    </div>
    <div class="asso-sec-content mt-3" v-if="tournamentsData.length > 0">
      <div class="d-flex justify-content-between flex-wrap align-items-center" style="gap: 5px;">
        <!-- Tournament Dropdown -->
        <div class="position-relative d-flex flex-wrap align-items-center" style="gap: 5px;">
          <div class="dropdown-wrapper">
            <div class="dropdown-button" :class="{
              'has-value': selectedTournamentName,
            }" @click="toggleDropdownDivision" v-click-outside="closeDropdownDivision">
              <div>
                <p class="association-data">{{ selectedTournamentName || "Division" }}</p>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </div>

            <div class="dropdown-menu-content" v-if="activeDropdownDivision">
              <input v-model="searchQuery" type="text" class="form-control" placeholder="Search Division" @click.stop
                @input="onSearchInput" />
              <div v-if="filteredTournaments.length === 0" class="no-results">No results found</div>
              <div class="dropdown-menu-content-inner" ref="dropdownMenu" v-else>
                <div v-for="tournament in filteredTournaments" :key="tournament.guid" class="dropdown-item"
                  @click="selectTournament(tournament)">
                  <span>{{ tournament.tournamentName }}</span>
                </div>
                <div class="position-relative py-3" v-if="showLoaderTournament === 1">
                  <div class="lds-dual-ring-media"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown-wrapper" v-click-outside="closeDropdownTeam">
            <button class="dropdown-button" :class="{
              'has-value': selectedTeams.length > 0,
            }" @click="toggleTeamDropdown">
              <span>{{
                selectedTeams.length >= 1
                  ? selectedTeams[0]
                  : "Teams"
              }}</span>
              <div class="badge-wrapper" v-if="selectedTeams.length > 1">
                <span class="counter-badge">+{{ selectedTeams.length - 1 }}</span>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </button>
            <div class="dropdown-menu-content" v-show="teamDropdownOpen">
              <div v-if="showLoader" class="lds-dual-ring-refresh"></div>
              <div class="data-wrap" v-if="!showLoader">
                <input type="text" v-model="teamSearchQuery" placeholder="Search Teams" class="form-control" @click.stop @input="onSearchInputTeam"/>
                <div class="dropdown-menu-content-inner">
                  <div v-if="filteredTeams.length === 0 && !showLoader" class="no-results">
                    No result found
                  </div>
                  <div v-else>
                    <div v-for="team in filteredTeams" :key="team.id" class="dropdown-item"
                      :class="{ selected: selectedTeams.includes(team.team.team_name) }"
                      @click="toggleTeamSelection(team)">
                      <input type="checkbox" :checked="selectedTeams.includes(team.team.team_name)"
                        class="checkbox circular-checkbox" />
                      <span>{{ team.team.team_name }}</span>
                    </div>
                  </div>
                </div>
                <!-- Clear Selection Button -->
                <button class="clear-btn" @click.stop="clearTeamSelection"
                  v-if="teamSearchQuery || selectedTeams.length > 0">
                  Clear Selection
                </button>
              </div>
            </div>
          </div>
          <div class="left-part-btns justify-content-start">
            <button :class="{ active: selectedFilter === 'all' }" @click="filterGames('all')">
              All
            </button>
            <button :class="{ active: selectedFilter === 'ongoing' }" @click="filterGames('ongoing')">
              Ongoing
            </button>
            <button :class="{ active: selectedFilter === 'final' }" @click="filterGames('final')">
              Final
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end" v-if="currentIsAdmin == '1'">
          <button class="btn manage-btn" @click="callModal(selectedTournament)">
            Add Game
          </button>
        </div>
      </div>
      <TournamentGames ref="gameList" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
        :tournamentData="tournamentsData" :showLoader="showLoaderMessage" :association_id="association_id"
        :associationId="associationId" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TournamentGames from "../Tournaments/TournamentGames.vue";
import TournamentAddGameModal from "../Tournaments/Modals/TournamentAddGameModal.vue";
import AddMessage from "./Modals/AddMessage.vue";
import MessageBoard from "../../views/MessageBoard.vue";

export default {
  name: "AssociationMessageBoard",
  components: {
    AddMessage,
    TournamentGames,
    TournamentAddGameModal,
    MessageBoard
  },
  data() {
    return {
      searchQuery: "",
      topic: "",
      selectedTopic: '',
      activeDropdown: false,
      messageBoardListenerAdded: false,
      selectedTournament: null,
      activeDropdownDivision: false,
      arrow_down: require('@/assets/Svg/arrow-down.svg'),
      associationId: 0,
      selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter
      dropdownLoading: false,
      previousScrollTop: 0,

      teamData: [],
      selectedTeams: [],
      teamDropdownOpen: false,
      teamSearchQuery: '',
      page: 1,
      teamLastPage: 1,
      search_icon: require('@/assets/Svg/Search.svg'),
    };
  },
  props: {
    tournamentsData: {
      type: Array,
    },
    showLoaderTournament: {
      type: Number,
    },
    messageBodyData: {
      type: Array,
      required: true
    },
    messageTopics: {
      type: Array,
      required: true
    },
    eventId: {
      type: Number,
      required: true,
    },
    association_id: {
      type: Number,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    msgLastPage: {
      type: Number,
    },
    messagepage: {
      type: Number,
    },
    showLoaderMessage: {
      type: Number
    }
  },
  computed: {
    selectedTopicName() {
      return this.messageTopics.find(t => t.id === this.selectedTopic)?.name || '';
    },
    selectedTournamentName() {
      const tournament = this.tournamentsData.find(t => t.guid === this.selectedTournament);
      return tournament ? tournament.tournamentName : "";
    },
    sortedTournaments() {
      if (!this.tournamentsData) return [];
      return [...this.tournamentsData].sort((a, b) => {
        const nameA = (a.tournamentName || "").toUpperCase();
        const nameB = (b.tournamentName || "").toUpperCase();
        return nameA.localeCompare(nameB);
      });
    },
    filteredTournaments() {
      const query = this.searchQuery.trim().toLowerCase();
      return this.sortedTournaments.filter(t =>
        (t.tournamentName || '').toLowerCase().includes(query)
      );
    },
    filteredTeams() {
      const query = this.teamSearchQuery.trim().toLowerCase();
      return this.teamData.filter(team =>
        (team.team.team_name || '').toLowerCase().includes(query)
      );
    },
    selectedTeamNames() {
      return this.selectedTeams.map(teamId => {
        const team = this.teamData.find(t => t.id === teamId);
        return team ? team.team.team_name : '';
      }).join(', ');
    }
  },
  watch: {
    tournamentsData: {
      handler(newData) {
        if (!newData || newData.length === 0) return;

        // Create a sorted copy
        const sortedData = [...newData].sort((a, b) => {
          const nameA = (a.tournamentName || '').toUpperCase();
          const nameB = (b.tournamentName || '').toUpperCase();
          return nameA.localeCompare(nameB);
        });

        const storedTournamentID = localStorage.getItem("tournamentID");

        if (storedTournamentID) {
          this.selectedTournament = storedTournamentID;
          this.getTournamentTeams(storedTournamentID);
        } else {
          this.selectedTournament = sortedData[0].guid;
          localStorage.setItem("tournamentID", this.selectedTournament);
          this.getTournamentTeams(this.selectedTournament);
        }
      },
      immediate: true
    },
  },
  methods: {
    onSearchInput(e) {
      this.searchQuery = e.target.value;
    },
    onSearchInputTeam(e) {
      this.teamSearchQuery = e.target.value;
    },
    formatDate(value) {
      if (!value) return "N/A";

      const date = new Date(value); // This converts UTC to local time

      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      const year = date.getFullYear();
      const month = monthNames[date.getMonth()];
      const day = String(date.getDate()).padStart(2, '0');
      let hour = date.getHours();
      const minute = String(date.getMinutes()).padStart(2, '0');
      const isPM = hour >= 12;
      const hour12 = hour % 12 === 0 ? 12 : hour % 12;
      const ampm = isPM ? "PM" : "AM";

      return `${month} ${day}, ${year}, ${hour12}:${minute} ${ampm}`;
    },
    handleScrolledToButtom(isVisible) {
      if (this.messagepage >= this.msgLastPage) {
        return;
      }
      if (isVisible) {

        this.$root.$emit("getMessageBoards"); // Emit event to notify parent component
      }
    },
    messageModal() {
      this.$root.$emit("addMessageModal", {
        eventId: this.eventId,
        association_id: this.association_id,
      });
    },
    callModal(tournament) {
      this.$root.$emit("openTournamentAddGameModal", tournament);
    },
    callManageTeamModal(tournament) {
      this.$root.$emit("openTournamentTeamsModal", tournament);
    },
    toggleDropdownDivision() {
      this.searchQuery = '';
      this.activeDropdownDivision = !this.activeDropdownDivision;
      this.$nextTick(() => {
        if (this.activeDropdownDivision && this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.addEventListener("scroll", this.onDropdownScroll);
        } else if (this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.removeEventListener("scroll", this.onDropdownScroll);
        }
      });
    },
    onDropdownScroll() {
      this.$emit("get-division-pagination");
    },
    closeDropdownDivision() {
      this.activeDropdownDivision = false;
    },
    toggleTeamDropdown() {
      this.teamDropdownOpen = !this.teamDropdownOpen;
    },

    toggleTeamSelection(team) {
      const teamName = team.team.team_name;
      const index = this.selectedTeams.indexOf(teamName);
      if (index === -1) {
        this.selectedTeams.push(teamName); // Store the full object
      } else {
        this.selectedTeams.splice(index, 1); // Remove by index
      }
      // Emit event with selected team names
      this.$root.$emit("filterGamesByTeams", this.selectedTeams);
    },

    clearTeamSelection() {
      this.selectedTeams = [];
      this.teamSearchQuery = '';
      this.$root.$emit("filterGamesByTeams", []);
    },

    closeDropdownTeam() {
      this.teamDropdownOpen = false;
    },

    async selectTournament(tournament) {
      this.selectedTournament = tournament.guid;
      this.teamData = []; // Clear existing teams data
      this.selectedTeams = []; // Clear selected teams
      this.page = 1;
      await this.getTournamentTeams(tournament.guid);
      this.$root.$emit("changeDivision", this.selectedTournament);
      localStorage.setItem("division", this.selectedTournament);
      this.closeDropdown();
    },
    toggleDropdown() {
      this.activeDropdown = !this.activeDropdown;
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    selectTopic(topic) {
      this.selectedTopic = topic.id;
      this.activeDropdown = false;
      this.handleChange(this.selectedTopic);
    },
    handleChange(topic) {
      this.$root.$emit("fetchMesagesForTopics", topic);

    },
    // handleRowClick(item) {
    //   if (this.currentIsAdmin === '1' || this.currentIsUmpire === '1') {
    //     this.$router.push({
    //       name: "MessagesBoard",
    //       params: { messageId: item.guid },
    //     });
    //   }
    // },
    handleRowClick(item) {
      if (this.currentIsAdmin === '1' || this.currentIsUmpire === '1') {
        this.$root.$emit("openMessageViewModal", item);
      }
    },
    async getTournamentTeams(guid) {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeams`,
          { tournament_guid: guid ? guid : this.tournamentData[0].guid, page: this.page, association_id: this.association_id, } // Include the page parameter
        );

        if (response.data.statusCode === 200) {
          const newData = response.data.data.data;
          newData.sort((a, b) => a.team_sr_no - b.team_sr_no);
          this.teamData = [...this.teamData, ...newData]; // Concatenate the new data with existing data
          this.teamLastPage = response.data.data.last_page;
          this.showLoader = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    filterGames(filter) {
      this.selectedFilter = filter;
      localStorage.setItem('gameFilter', this.selectedFilter);
      this.$root.$emit("FilterGames", this.selectedFilter);
    },
  },
  mounted() {
    localStorage.setItem("eventid", this.eventId);
    localStorage.setItem('association_id', this.association_id);
    if (!this.messageBoardListenerAdded) {

      this.messageBoardListenerAdded = true;
    }
    this.$root.$on("resetTopic", () => {
      this.selectedTopic = '';
    });
  },
};
</script>
